import React, { useEffect, useLayoutEffect, useState } from 'react'
import { Tabs, Tab } from 'react-bootstrap';
import { Loading } from '../loading/Loading';
import { DVDD } from '../right-info/ChatLuongDat';
import { DanCu } from '../right-info/DanCu';
import { DeXuat } from '../right-info/DeXuat';
import { DuongSat } from '../right-info/DuongSat';
import { HienTrang } from '../right-info/HienTrang';
import { RgHuyen } from '../right-info/RgHuyen';
import { RgXa } from '../right-info/RgXa';
import { TenHuyen } from '../right-info/TenHuyen';
import { TenThon } from '../right-info/TenThon';
import { TenXa } from '../right-info/TenXa';
import { ThichHop } from '../right-info/ThichHop';
import { BinhDo } from '../right-info/BinhDo';
import { GiaoThong } from '../right-info/GiaoThong';
import { ThongTinHanhChinh } from '../right-info/ThongTinHanhChinh';
import { ThongTinNongHoa } from '../right-info/ThongTinNongHoa';
import { ThongTinTrungViLuong } from '../right-info/ThongTinTrungViLuong';
import { ThoNhuong } from '../right-info/ThoNhuong';
import { ThuyLoi } from '../right-info/ThuyLoi';
import stylelocal from "./SidebarLayer.module.css"

export const SidebarLayer = (props) => {
    const [loading, setLoading] = useState(false);
    const [key, setKey] = useState('');
    const [showTab, setShowTab] = useState(false);
    const [thongTinSuDungDat, setThongTinSuDungDat] = useState({});
    const [thongTinThoNhuong, setThongTinThoNhuong] = useState({});
    const [thongTinThichHop, setThongTinThichHop] = useState({});
    const [thongTinHienTrang, setThongTinHienTrang] = useState({});
    const [thongTinChatLuongDat, setThongTinChatLuongDat] = useState({});
    const [thongTinNongHoa, setThongTinNongHoa] = useState({});
    const [thongTinHanhChinh, setThongTinHanhChinh] = useState({});
    const [thongTinTrungViLuong, setThongTinTrungViLuong] = useState({});
    const [thongTinRgHuyen, setThongTinRgHuyen] = useState({});
    const [thongTinRgXa, setThongTinRgXa] = useState({});
    const [thongTinTenHuyen, setThongTinTenHuyen] = useState({});
    const [thongTinTenXa, setThongTinTenXa] = useState({});
    const [thongTinTenThon, setThongTinTenThon] = useState({});
    const [thongTinDanCu, setThongTinDanCu] = useState({});
    const [thongTinGiaoThong, setThongTinGiaoThong] = useState({});
    const [thongTinThuyLoi, setThongTinThuyLoi] = useState({});
    const [thongTinBinhDo, setThongTinBinhDo] = useState({});
    const [thongTinDuongSat, setThongTinDuongSat] = useState({});
    var width = window.innerWidth - props.width;
    if (window.innerWidth < 768) {
        width = window.innerWidth - 10;
    }
    const [xPosition, setX] = React.useState(width);
    const toggleMenu = () => {
        if (xPosition < width) {
            setX(width);
        } else {
            setX(width - 290);
        }
    };
    useLayoutEffect(() => {
        function updateSize() {
            width = window.innerWidth - props.width;
            setX(width)
        }
        window.addEventListener('resize', updateSize);
        return () => window.removeEventListener('resize', updateSize);
    }, []);
    useEffect(() => {
        if (props.x > 0) {
            setKey(props.tabSelect);
        }
    }, [props.x]);
    useEffect(() => {
        const show = props.listLopBanDos.findIndex(x => x.Checked && (x.ParentId !== 'BANDONEN' || x.Ma === 'BDRGXA') && x.ParentId !== 'BANDOVETINH'  && x.LayerName != null) !== -1;
        setShowTab(show);
    }, [props.listLopBanDos]);
    useEffect(() => {
        const tableName = props.listLopBanDos.filter(x => x.Checked && (x.ParentId !== 'BANDONEN' || x.Ma === 'BDRGXA') && x.ParentId !== 'BANDOVETINH' && x.LayerName != null);
        let k = props.tabSelect;
        if (tableName.length > 0 && k === '') {
            k = tableName[0].Ma;
        }
        switch (k) {
            case 'BDHANHCHINHHUYEN':
                setThongTinHanhChinh(props.thongTin);
                break;
            case 'BDDEXUATSUDUNGDAT':
                setThongTinSuDungDat(props.thongTin);
                break;
            case 'BDTHONHUONG':
                setThongTinThoNhuong(props.thongTin);
                break;
            case 'BDTHICHHOPSUDUNGDAT':
                setThongTinThichHop(props.thongTin);
                break;
            case 'BDHIENTRANGSUDUNGDAT':
                setThongTinHienTrang(props.thongTin);
            case 'BDCHATLUONGDAT':
                setThongTinChatLuongDat(props.thongTin);
                break;
            case 'BDTRUNGVILUONG':
                setThongTinTrungViLuong(props.thongTin);
                break;
            case 'BDHANHCHINHHUYEN':
                setThongTinHanhChinh(props.thongTin);
                break;
            case 'BDRANHGIOIHUYEN':
                setThongTinRgHuyen(props.thongTin);
                break;
            case 'BDRGXA':
                setThongTinRgXa(props.thongTin);
                break;
            case 'BDTENHUYEN':
                setThongTinTenHuyen(props.thongTin);
                break;
            case 'BDTENXA':
                setThongTinTenXa(props.thongTin);
                break;
            case 'BDTENTHON':
                setThongTinTenThon(props.thongTin);
                break;
            case 'BDDANCU':
                setThongTinDanCu(props.thongTin);
                break;
            case 'BDTHUYLOI':
                setThongTinThuyLoi(props.thongTin);
                break;
            case 'BDGIAOTHONG':
                setThongTinGiaoThong(props.thongTin);
                break;
            case 'BDBINHDO':
                setThongTinBinhDo(props.thongTin);
                break;
            case 'BDDUONGSAT':
                setThongTinDuongSat(props.thongTin);
                break;
        }
    }, [props.thongTin])
    useEffect(() => {
        setKey(props.tabSelect);
    }, [props.tabSelect])

    useEffect(() => {
        if (props.show > 0 && xPosition > width - 290) {
            toggleMenu();
        }
    }, [props.show]);

    const clickTab = async (k) => {
        setKey(k)
        // const tableName = props.listLopBanDos.filter(x => x.Ma === k);
        // console.log(tableName[0].TableName);
        // props.updateTableSelect(tableName[0].TableName);
        props.updateTableSelect(k);
    }
    const adminstyle = {
        height: 'calc(100vh - 140px)'
    }

    const showEditThongTin = (e) => {
        props.showEditThongTin(e);
    }


    return (
        <React.Fragment>
            <div
                className={stylelocal.sidebar}
                style={{
                    transform: `translatex(${xPosition}px)`,
                    width: width,

                }}
            >
                <button
                    onClick={() => toggleMenu()}
                    className={stylelocal.togglemenu}
                    style={{
                        transform: `translate(${-25}px, 0px)`
                    }}
                >
                    {
                        <div className={stylelocal.outer}>
                            <div className={stylelocal.inner + ' ' + stylelocal.rotate}>THÔNG TIN</div>
                        </div>
                    }
                </button>
                <div className={stylelocal.sidecontent} style={props.admin ? adminstyle : null}>
                    {
                        showTab === true ? <Tabs
                            id="controlled-tab-example"
                            activeKey={key}
                            onSelect={(k) => clickTab(k)}
                        >
                            {
                                props.listLopBanDos.filter(x => (x.Type > 1 || x.Ma==='BDRGXA') && x.Checked).map((item, index) => {
                                    switch (item.Ma) {
                                        case 'BDHANHCHINHHUYEN':
                                            return (
                                                <Tab eventKey={item.Ma} title="Hành chính">
                                                    <ThongTinHanhChinh thongTin={thongTinHanhChinh} showEditThongTin={() => { showEditThongTin(thongTinHanhChinh) }} admin={props.admin} />
                                                </Tab>
                                            )
                                        case 'BDDEXUATSUDUNGDAT':
                                            return (
                                                <Tab eventKey={item.Ma} title="Đề xuất">
                                                    <DeXuat thongTin={thongTinSuDungDat} showEditThongTin={() => { showEditThongTin(thongTinSuDungDat) }} admin={props.admin} />
                                                </Tab>
                                            )
                                        case 'BDTHONHUONG':
                                            return (
                                                <Tab eventKey={item.Ma} title="Thổ nhưỡng">
                                                    <ThoNhuong thongTin={thongTinThoNhuong} showEditThongTin={(e) => { showEditThongTin(thongTinThoNhuong) }} admin={props.admin} />
                                                </Tab>
                                            )
                                        case 'BDTHICHHOPSUDUNGDAT':
                                            return (
                                                <Tab eventKey={item.Ma} title="Thích hợp">
                                                    <ThichHop thongTin={thongTinThichHop} showEditThongTin={(e) => { showEditThongTin(thongTinThichHop) }} admin={props.admin} />
                                                </Tab>
                                            )
                                        case 'BDHIENTRANGSUDUNGDAT':
                                            return (
                                                <Tab eventKey={item.Ma} title="Hiện trạng">
                                                    <HienTrang thongTin={thongTinHienTrang} showEditThongTin={() => { showEditThongTin(thongTinHienTrang) }} admin={props.admin} />
                                                </Tab>
                                            )
                                        case 'BDCHATLUONGDAT':
                                            return (
                                                <Tab eventKey={item.Ma} title="Chất lượng đất">
                                                    <DVDD thongTin={thongTinChatLuongDat} showEditThongTin={(e) => { showEditThongTin(thongTinChatLuongDat) }} admin={props.admin} />
                                                </Tab>
                                            )
                                        case 'BDTRUNGVILUONG':
                                            return (
                                                <Tab eventKey={item.Ma} title="Trung vi lượng">
                                                    <ThongTinTrungViLuong thongTin={thongTinTrungViLuong} showEditThongTin={(e) => { showEditThongTin(thongTinTrungViLuong) }} admin={props.admin} />
                                                </Tab>
                                            )
                                        case 'BDRANHGIOIHUYEN':
                                            return (
                                                <Tab eventKey={item.Ma} title="Ranh giới huyện">
                                                    <RgHuyen thongTin={thongTinRgHuyen} showEditThongTin={(e) => { showEditThongTin(thongTinRgHuyen) }} admin={props.admin} />
                                                </Tab>
                                            )
                                        case 'BDRGXA':
                                            return (
                                                <Tab eventKey={item.Ma} title="Bản đồ xã">
                                                    <RgXa thongTin={thongTinRgXa} showEditThongTin={(e) => { showEditThongTin(thongTinRgXa) }} admin={props.admin} />
                                                </Tab>
                                            )
                                        case 'BDTENHUYEN':
                                            return (
                                                <Tab eventKey={item.Ma} title="Tên huyện">
                                                    <TenHuyen thongTin={thongTinTenHuyen} showEditThongTin={(e) => { showEditThongTin(thongTinTenHuyen) }} admin={props.admin} />
                                                </Tab>
                                            )
                                        case 'BDTENXA':
                                            return (
                                                <Tab eventKey={item.Ma} title="Tên xã">
                                                    <TenXa thongTin={thongTinTenXa} showEditThongTin={(e) => { showEditThongTin(thongTinTenXa) }} admin={props.admin} />
                                                </Tab>
                                            )
                                        
                                        case 'BDTENTHON':
                                        return (
                                            <Tab eventKey={item.Ma} title="Tên thôn">
                                                <TenThon thongTin={thongTinTenThon} showEditThongTin={(e) => { showEditThongTin(thongTinTenThon) }} admin={props.admin} />
                                            </Tab>
                                        )
                                        case 'BDDANCU':
                                            return (
                                            <Tab eventKey={item.Ma} title="Vùng dân cư">
                                                <DanCu thongTin={thongTinDanCu} showEditThongTin={(e) => { showEditThongTin(thongTinDanCu) }} admin={props.admin} />
                                            </Tab>
                                            )
                                        
                                        case 'BDGIAOTHONG':
                                            return (
                                            <Tab eventKey={item.Ma} title="Vùng giao thông">
                                                <GiaoThong thongTin={thongTinGiaoThong} showEditThongTin={(e) => { showEditThongTin(thongTinGiaoThong) }} admin={props.admin} />
                                            </Tab>
                                            )
                                        
                                        case 'BDTHUYLOI':
                                            return (
                                                <Tab eventKey={item.Ma} title="Vùng thủy lợi">
                                                    <ThuyLoi thongTin={thongTinThuyLoi} showEditThongTin={(e) => { showEditThongTin(thongTinThuyLoi) }} admin={props.admin} />
                                                </Tab>
                                            )
                                        case 'BDBINHDO':
                                            return (
                                            <Tab eventKey={item.Ma} title="Đường bình độ">
                                                <BinhDo thongTin={thongTinBinhDo} showEditThongTin={(e) => { showEditThongTin(thongTinBinhDo) }} admin={props.admin} />
                                            </Tab>
                                            )
                                        
                                        case 'BDDUONGSAT':
                                            return (
                                            <Tab eventKey={item.Ma} title="Đường sắt">
                                                <DuongSat thongTin={thongTinDuongSat} showEditThongTin={(e) => { showEditThongTin(thongTinDuongSat) }} admin={props.admin} />
                                            </Tab>
                                            )
                                    }
                                })
                            }

                        </Tabs> : <h5 className="text-center">Bạn chưa chọn bản đồ</h5>
                    }
                </div>
            </div>
            <Loading loading={loading}></Loading>
        </React.Fragment>
    )
}
